import {useState, useEffect} from "react";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import axios from "axios";
import {base, unit, expance_type} from "../../../api";

export default function AutoAddRemoveRows({rows, setRows, rowsError}) {
	const [unitOptions, setUnitOptions] = useState([]);
	const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);

	useEffect(() => {
		axios
			.all([axios.get(base + unit), axios.get(base + expance_type)])
			.then(
				axios.spread((unitRes, expanceRes) => {
					setUnitOptions(unitRes.data);
					setExpenseTypeOptions(expanceRes.data);
				}),
			)
			.catch(error => {
				console.error("Error fetching data:", error);
			});
	}, []);

	const handleRowChange = (value, field, index) => {
		const updatedRows = [...rows];
		updatedRows[index][field] = value;
		setRows(updatedRows);
	};

	const addRow = () => {
		setRows([...rows, {description: "", unit: null, price: null, count: null, expense_type: null}]);
	};

	const removeRow = index => {
		setRows(rows.filter((_, i) => i !== index));
	};
	// console.log(rows);

	return (
		<div className="row m-0 d-flex justify-content-center align-items-center">
			<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-2 p-0">
				Related products
			</div>
			{rowsError && (
				<div className="text-danger text-center col-12">
					Related products cannot be empty. Please fill all fields.
				</div>
			)}
			{rows.map((row, index) => (
				<div key={index} className="card mb-3 w-100 px-4 py-2 rounded-4">
					<div className="row align-items-center">
						<div className="col-12 p-0">
							<div className="row align-items-center m-0">
								<Dropdown
									value={expenseTypeOptions.find(opt => opt.id === row.expense_type) || null}
									options={expenseTypeOptions}
									optionLabel="title_am"
									placeholder="Ծախսի տեսակ"
									style={{height: "50px"}}
									className="col-lg-3 p-0 my-2 me-3"
									invalid={rowsError}
									onChange={e => handleRowChange(e.value.id, "expense_type", index)}
								/>
								<div className="col-lg-4 py-0">
									<div className="row">
										<InputNumber
											value={row.price}
											placeholder="Արժեք"
											style={{height: "50px"}}
											className="col-lg-4 p-0 my-2 pe-3"
											onValueChange={e => handleRowChange(e.value, "price", index)}
											invalid={rowsError}
										/>
										<Dropdown
											value={unitOptions.find(opt => opt.id === row.unit) || null}
											options={unitOptions}
											optionLabel="title_am"
											placeholder="Չափի միավոր"
											style={{height: "50px"}}
											className="col-lg-5 p-0 my-2"
											invalid={rowsError}
											onChange={e => handleRowChange(e.value.id, "unit", index)}
										/>
										<InputNumber
											value={row.count}
											placeholder="Քանակ"
											style={{height: "50px"}}
											className="col-lg-3 p-0 my-2 px-3"
											invalid={rowsError}
											onValueChange={e => handleRowChange(e.value, "count", index)}
										/>
									</div>
								</div>
								<div className="col-lg-4 p-0">
									<InputText
										value={row.description}
										placeholder="Ապրանքի բնութագիր"
										style={{height: "50px"}}
										className="my-2"
										invalid={rowsError}
										onChange={e => handleRowChange(e.target.value, "description", index)}
									/>
								</div>
								<div className="col p-0 text-end">
									<Button
										icon="pi pi-trash"
										className="p-button-danger"
										rounded
										onClick={() => removeRow(index)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			))}
			<div className="text-end mt-3">
				<Button rounded label="Add Row" icon="pi pi-plus" severity="success" onClick={addRow} />
			</div>
		</div>
	);
}
